import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { DataProviderService } from 'src/app/services/data-provider.service';
import { MessagingService } from 'src/app/services/messaging.service';
import { NetworkService } from 'src/app/services/network.service';
import { ResponseTimeService } from 'src/app/services/response-time.service';
import { environment } from 'src/environments';
import { IonModal } from '@ionic/angular';
import { StorageService } from 'src/app/services/storage.service';
import { RestService } from 'src/app/services/rest.service';
import {
  BackButtonService,
  BackButtonConfig,
} from 'src/app/services/back-button.service';
import { Observable } from 'rxjs';
import { UnreadChatsService } from 'src/app/services/unread-chats.service';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss'],
})
export class UserInfoComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  public version: string;
  public user: string;
  public text = '';
  pendingRequestsCount = 0;
  pendingRequestsSending = false;
  longestResponseTime = 0;
  isModalOpen = false;
  public backButtonConfig$: Observable<BackButtonConfig>;
  public hasUnreadChats$: Observable<boolean>;

  private languageList = [
    { key: 'en', name: 'ADMINISTRATION.USER_PROFILE.LANGUAGES.ENGLISH' },
    { key: 'de', name: 'ADMINISTRATION.USER_PROFILE.LANGUAGES.GERMAN' },
  ];

  constructor(
    private messaging: MessagingService,
    private dataProvider: DataProviderService,
    public networkService: NetworkService,
    private responseTimeService: ResponseTimeService,
    private translate: TranslateService,
    private auth: AuthService,
    private storage: StorageService,
    private rest: RestService,
    private backButtonService: BackButtonService,
    private unreadChatsService: UnreadChatsService
  ) {
    this.backButtonConfig$ = this.backButtonService.getBackButtonConfig();
    this.hasUnreadChats$ = this.unreadChatsService.getHasUnreadChats();
  }

  ngOnInit(): void {
    // this.storage.get('language').then((val) => {
    //   if (val && val.length > 0) {
    //     val = val.replaceAll('"', '');
    //     this.rest.selectedLanguage = val;

    //     this.translate.use(val);
    //   } else {
    //     this.storage.store('language', 'en');
    //     this.rest.selectedLanguage = 'en';
    //     this.translate.use('en');
    //   }
    // });
    this.version = environment.version;
    this.user = this.dataProvider.getUserName();

    this.longestResponseTime =
      this.responseTimeService.getLongestResponseTime();
    this.updateText();
    this.subscribeForPendingEvents();
    this.subscribeForResponseTimeEvents();
  }

  ionViewWillEnter(): void {}

  subscribeForPendingEvents(): void {
    this.messaging.pendingRequestsSent.subscribe(() => {
      this.pendingRequestsSending = false;
      this.updateText();
    });
    this.messaging.pendingRequestsChanged.subscribe((count) => {
      this.pendingRequestsCount = count;
      this.updateText();
    });
    this.messaging.pendingRequestsSending.subscribe((count) => {
      this.pendingRequestsSending = true;
      this.pendingRequestsCount = count;
      this.updateText();
    });
  }

  subscribeForResponseTimeEvents(): void {
    this.messaging.longestResponseTimeChanged.subscribe((time: number) => {
      this.longestResponseTime = time;
      this.updateText();
    });
  }

  setOpen(isOpen: boolean) {
    this.isModalOpen = isOpen;
  }

  onWillDismiss(modalEvent: Event) {
    this.isModalOpen = false;
  }

  changeLanguage(e) {
    this.translate.use(e.detail.value);
    this.storage.store('language', e.detail.value);
    this.rest.selectedLanguage = e.detail.value;
  }

  updateText(): void {}

  logout() {
    this.auth.logoutNew();
  }

  onClick(): void {
    this.responseTimeService.resetLongestResponseTime();
  }

  useLanguage(language: string): void {
    this.translate.use(language);
  }

  goBack(): void {
    this.backButtonService.goBack();
  }
}
